export const popsConfig = {
  host: 'https://login.megazone.com',
  clientId: process.env.REACT_APP_POPS_CLIENT_ID,
  redirectUrl: '/megazone/login',
  initiateLoginUrl: '/login'
}
